import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CompanyInfo:{},
    CategoryList:[],
  },
  getters: {

  },
  mutations: {
    setCompanyInfo(state,value){
      state.CompanyInfo=value;
    },
    setCategoryList(state,value){
      state.CategoryList=value;
    },
  },
  actions: {
    setCompanyInfo({commit},value){
      commit('setCompanyInfo',value);
    },
    setCategoryList({commit},value){
      commit('setCategoryList',value);
    },
  },
  modules: {
  }
})
